module.exports = __webpack_public_path__ + "static/media/googleplay.db9b21a1.png";